<template>
  <v-app :class="['theme--frontpage', {'splash-background': !mobile}]">
    <v-app-bar
      :height="smAndDown ? 100 : 160"
      absolute
      elevation="0"
      flat
      tile
      color="transparent"
    >
      <v-container>
        <v-row>
          <v-col>
            <v-img
              id="io-logo"
              src="@/assets/IO.svg"
              :alt="$t('appLayoutStrings.toolbarTitle')"
              width="300"
              height="70"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-main>
      <slot />
      <app-footer />
    </v-main>
  </v-app>
</template>

<script setup>
import AppFooter from './components/AppFooter';
import { useDisplay } from 'vuetify';

const { mobile, smAndDown } = useDisplay();
</script>

<style lang="scss">
@mixin gradient-image($bgcolor, $image) {
  background: $bgcolor;
  background: linear-gradient(
  90deg,
  $bgcolor 35%,
  rgba(0, 0, 0, 0) 75%,
  rgba(0, 0, 0, 0) 100%
  ),
  $image;
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: right;
  background-position-y: center;
}

.theme--frontpage {
  background: none;
  .frontpage-title {
    font-size: 2.75rem !important;
  }

  .frontpage-font-size {
    font-size: 18px !important;
  }

  ul.checkmarked {
    list-style: none;
  }

  a {
    color: rgb(var(--v-theme-inverted));
  }

  ul.checkmarked li {
    margin-bottom: 0.7rem;
  }

  ul.checkmarked li:before {
    content: "✓";
    margin-right: 0.8rem;
    font-size: 14px;
  }

  .v-application__wrap {
    background: none;
  }

  background: rgb(var(--v-theme-primary));
  color: rgb(var(--v-theme-inverted));

  &.splash-background {
    @include gradient-image(rgb(var(--v-theme-primary)), url("~@/assets/relay.jpg"));
  }

    .frontpage-button {
      box-shadow: 0px 11px 6px rgb(var(--v-theme-primary)) !important;
    }
}
</style>
